var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Slider.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["slides", "options"], 
[], 
function (l_slides, l_options, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slides", l_slides);
frame.set("options", l_options);
var t_2 = "";t_2 += "<div class=\"Slider ";
frame = frame.push();
var t_5 = runtime.memberLookup((l_options),"modifiers");
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("m", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
t_2 += "Slider--";
t_2 += runtime.suppressValue(t_6, env.opts.autoescape);
;
}
}
frame = frame.pop();
t_2 += "\">\n        ";
if(env.getFilter("length").call(context, l_slides)) {
t_2 += "\n            <div class=\"Slider-contents\">\n                ";
frame = frame.push();
var t_9 = l_slides;
if(t_9) {var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("s", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
t_2 += "\n                    <div class=\"Slider-slide\" data-order=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_2 += "\">\n                        ";
t_2 += "\n                        ";
if(runtime.memberLookup((l_options),"frame")) {
t_2 += "\n                            <div class=\"Frame Frame--simple\"></div>\n                        ";
;
}
t_2 += "\n\n                        ";
if(runtime.memberLookup((t_10),"title")) {
t_2 += "\n                            <a class=\"Slider-link u-Heading\" href=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((t_10),"url"), env.opts.autoescape);
t_2 += "\">\n                                <span class=\"Slider-linkContents\">\n                                    <span class=\"Slider-titleContainer\">\n                                        <span class=\"Slider-title\">";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_10),"title")), env.opts.autoescape);
t_2 += "</span>\n                                    </span>\n                                    <span class=\"Slider-linkMessage\">";
t_2 += runtime.suppressValue((lineno = 17, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Подробнее"])), env.opts.autoescape);
t_2 += "</span>\n                                </span>\n                            </a>\n                        ";
;
}
t_2 += "\n\n                        <div class=\"Slider-overlay\"></div>\n\n                        ";
t_2 += "\n                        ";
t_2 += "\n                        <div class=\"Slider-img u-Preload u-Cover\">\n                            <img src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_10),"img")),"main"), env.opts.autoescape);
t_2 += "\" srcset=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_10),"img")),"main_2x"), env.opts.autoescape);
t_2 += " 2x\"\n                                 alt=\"";
if(runtime.memberLookup((t_10),"title")) {
t_2 += runtime.suppressValue(runtime.memberLookup((t_10),"title"), env.opts.autoescape);
;
}
t_2 += "\">\n                        </div>\n                    </div>\n                ";
;
}
}
frame = frame.pop();
t_2 += "\n            </div>\n\n            <div class=\"Slider-counter\">\n            <span class=\"Slider-currentCounter\">\n                <span class=\"Slider-numberValue\">01</span>\n            </span>\n                <span>of</span>\n                <span class=\"Slider-numberTotal\">";
t_2 += runtime.suppressValue("%02d" % runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"length"), env.opts.autoescape);
t_2 += "</span>\n            </div>\n\n            <button class=\"Slider-btn Slider-btn--prev u-Btn\">\n                ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Slider/Slider-prev.svg")), env.opts.autoescape);
t_2 += "\n            </button>\n\n            <button class=\"Slider-btn Slider-btn--next u-Btn\">\n                ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Slider/Slider-next.svg")), env.opts.autoescape);
t_2 += "\n            </button>\n        ";
;
}
t_2 += "\n    </div>";
t_2 += runtime.suppressValue((lineno = 50, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("Slider");
context.setVariable("Slider", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Slider.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Slider/Slider.jinja
// module id = 30
// module chunks = 0